import styled from 'styled-components/macro';
// import { colors } from 'styles/shared.styles';

export const Container = styled.div``;

export const TableContainer = styled.div``;
